import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { RecentBookingsResponseSchema } from "../schemas/dashboardV2Schemas";

const API_VERSION = 'v4';

const useDashboardRecentBookings = (property_id?: string) => {
    return useQuery({
        queryKey: ['dashboard-recent-bookings', property_id],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/dashboard/bookings/recent`, {
                params: { property_id }
            });
            const validationResult = RecentBookingsResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Recent Bookings data format");
            }
            return validationResult.data;
        },
        enabled: !!property_id,
        retry: import.meta.env.VITE_MAX_RETRY ? parseInt(import.meta.env.VITE_MAX_RETRY as string) : 1,
        refetchOnWindowFocus: false
    });
};

export default useDashboardRecentBookings;
